import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import {
  selectModels,
} from '../../actions/advisor';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import s from './SelectModelForm.css';

library.add(faCircleNotch);

class SelectModelForm extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }

  selectModels = (event) => {
    const {
      client,
    } = this.props;
    event.preventDefault();
    this.setState({
      showModal: true,
    });

    this.props.selectModels(client).then(() => {
      this.setState({
        showModal: false,
      });
    });
  }

  checkPersonalizeOK(client) {
    let hasPort = false;
    let hasGoal = false;
    let hasInfo = false;
    let hasLA = false;
    if (client.holdings && client.holdings.length > 0) {
      hasPort = true;
    }
    if (client.laScore > 0) {
      hasLA = true;
    }
    const sortedResults = client.results.filter((result) => result.name === 'loss-aversion');
    if (sortedResults.length > 0) {
      hasLA = true;
    }
    if (client.retireMonthlyIncome > 0) {
      hasGoal = true;
    }
    if (client.birthYear && client.retireAge) {
      hasInfo = true;
    }
    return (hasPort && hasGoal && hasInfo && hasLA);
  }

  render() {
    const {
      showModal,
    } = this.state;
    const {
      client,
    } = this.props;

    const personalizeOK = this.checkPersonalizeOK(client);

    return (
      <React.Fragment>
        <div>
          <div className={'row'}>
            <div className='col-md-12'>
              {personalizeOK && client.isDirty && !showModal &&
                <div
                  onClick={this.selectModels}
                  className={s.saveButton}
                >RUN THE MODEL ANALYSIS FOR {client.firstName}</div>
              }
              {/* {!personalizeOK &&
                <div className={s.message}>PLEASE COMPLETE ALL STEPS</div>
              } */}
            </div>
          </div>
        </div>
        <Modal show={showModal}>
          <Modal.Body style={{ textAlign: 'center' }}>
            <h4>
              Analyzing WisdomTree Models for {client.firstName}<br />
              <FontAwesomeIcon icon="circle-notch" size="lg" style={{ marginTop: '20px', color: '#37BAC0' }} spin />
            </h4>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {
  selectModels,
})(SelectModelForm);




// WEBPACK FOOTER //
// ./src/components/AdvisorMode/SelectModelForm.js